<style lang="less">
  .detail {
    .extra{
      padding-bottom: 8px;
      .time {
        color: #959595;
      }
      .price {
        color: #959595;
      }
    }
  }
  .boxer {
    display: flex;
    flex-flow: column;
    margin: 2px 0;
    height: max-content;
    border-radius: 4px;
    flex: 1;
    border: 1px solid #fff;
    margin-bottom: 1px;
    overflow: hidden;
    &.func{
      .extra{
        margin-left: 0;
      }
    }
  }
  // oocss
  .extra{
    background: #fff;
    padding-left: 36px;
    overflow: hidden;
    .box{
      width: 175px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .line{
      background-color: #f2f2f2;
      width: 1px;
      height: 16px;
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: .5s;
  }
  .fade-enter, .fade-leave-to {
    height: 0;

  }
</style>
<template>
  <div @click="$emit('select')" class="boxer">
    <slot></slot>
    <!-- TODO: 此处可以加动画   -->
    <transition name="fade">
    <div v-if="detail && fn" class="extra">
      <div class="box">
        <a-button type="link" size="small" class="price">
          <span v-if="fn.max_price && fn.min_price !== fn.max_price">¥ {{ fn.min_price }} ~ {{ fn.max_price }}</span>
          <span v-else>¥ {{ fn.price }}</span>
        </a-button>
        <div class="line"></div>
        <a-button type="link" size="small" class="time">
          <span v-if="fn.max_time && fn.min_time !== fn.max_time">{{ fn.min_time }} ~ {{fn.max_time}} 小时</span>
          <span v-else>{{ fn.time }}小时</span>
        </a-button>
      </div>
    </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: ['detail', 'fn', 'edit'],
  updated () {
    // if (this.edit) {
    //   console.log(this.edit, this.fn)
    //
    //   console.log(this.fn.name)
    //   console.log(this.fn.max_time, this.fn.min_time, this.fn.time)
    //   console.log(this.fn.max_price, this.fn.min_price, this.fn.price)
    //   console.log('')
    // }
  }
}
</script>
